// @flow
import universal from "react-universal-component";
import UniversalComponentError from "../components/UniversalComponentError";

const createUniversalComponent = (page) =>
  // $FlowFixMe this works but flow hates it
  universal(import(`../pages/${page}/index`), {
    loading: () => null,
    error: UniversalComponentError,
    ignoreBabelRename: true,
  });

type UniversalRouteConfig = {
  name: string,
  path: string,
  exact?: boolean,
  props?: any,
};

const createUniversalRoute = ({ name, ...route }: UniversalRouteConfig) => ({
  ...route,
  component: createUniversalComponent(name),
});

export default createUniversalRoute;
